module.exports = __webpack_public_path__ + "media/images/happy-city-index-logo-cy-715bfac89607e253c0c0c0f4c07dbea0.png";